<template>
  <v-tooltip top>
    <v-btn fab dark small color="amber darken-2" slot="activator" @click="print()">
      <v-icon>print</v-icon>
    </v-btn>
    <span>Download PDF</span>
  </v-tooltip>
</template>

<script>
export default {
  methods: {
    print() {
      this.$emit("print");
    }
  }
};
</script>

<style>
</style>
